import { MenuIdDashboards } from '@jira/navigation-apps__constants/src/MenuIdDashboards.tsx';
import { SidebarIdContent } from '@jira/navigation-apps__constants/src/SidebarIdContent.tsx';
import { DASHBOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { capabilitiesConfigResource } from '@jira/router-resources__viz-platform/src/capabilitiesConfigResource.tsx';
import { dashboardAnalyticsEditRoute } from '@jira/router-routes__dashboard-routes/src/dashboardAnalyticsEditRoute.tsx';
import { dashboardsAnalyticsEntryPoint } from '@jira/global-pages__dashboards-analytics/src/dashboardsAnalyticsEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { nav4SidebarContentCoreEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-core/src/nav4SidebarContentCoreEntryPoint.entrypoint.tsx';
import { gsnSidebarContentEntryPoint } from '@jira/nav-platform-integration__sidebar/src/gsnSidebarContentEntryPoint.entrypoint.tsx';
import { nav4DashboardsContentEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-dashboards/src/ui/dashboards/default/async-content/nav4DashboardsContentEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

export const dashboardAnalyticsEditRouteEntry: Route = createEntry(
	dashboardAnalyticsEditRoute,
	() => ({
		group: 'dashboard',
		entryPoint: () => {
			if (expVal('platform_avp_dual_create_dashboards', 'isEnabled', false)) {
				return fg('navx-global-side-nav') ? GSNPageEntryPoint : pageEntryPoint;
			}
			return notFoundPageEntrypoint;
		},
		layout: globalLayout,
		navigation: {
			menuId: MenuIdDashboards,
			sidebarId: SidebarIdContent, // Nav4
		},
		resources: [
			...getNavigationResources(
				fg('navx-global-side-nav') ? { isUsingSidebarEntrypoint: true } : undefined,
			),
			resourceWithCondition(
				() => expVal('platform_avp_dual_create_dashboards', 'isEnabled', false),
				capabilitiesConfigResource,
			),
		],
		meta: {
			capability: DASHBOARD,
		},
		earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
		ufoName: 'dashboard-v2',
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);

const pageEntryPoint = createPageEntryPoint({
	main: dashboardsAnalyticsEntryPoint,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: { dashboards: { entryPoint: nav4DashboardsContentEntryPoint } },
	},
});

const GSNPageEntryPoint = createPageEntryPoint({
	main: dashboardsAnalyticsEntryPoint,
	leftSidebar: {
		sidebar: gsnSidebarContentEntryPoint,
		entryPoints: { dashboards: { entryPoint: nav4DashboardsContentEntryPoint } },
	},
});
